import { Component, OnInit } from '@angular/core';
import { Constants } from '../constants/constants';
import { I18n } from '../i18n.service';

@Component({
  selector: 'app-alert-notify',
  templateUrl: './alert-notify.component.html',
  styleUrls: ['./alert-notify.component.scss']
})
export class AlertNotifyComponent implements OnInit {
  dialogContent
  constructor(public i18n: I18n) { 
    this.dialogContent = this.i18n.t(`Be sure to confirm notifications are enabled for the ${Constants.appName} app in your iPhone Settings`)
  }

  ngOnInit() {
  }

}
